import { QuestionComponentProps } from "..";

import { SalaryPreferenceSelector } from "./components/SalaryPreferenceSelector";

export function SalaryPreference({
  setNextEnabled,
}: QuestionComponentProps): React.ReactElement {
  return (
    <SalaryPreferenceSelector
      onPreferenceSet={(isPreferenceSet: boolean) =>
        setNextEnabled?.(isPreferenceSet)
      }
    />
  );
}
